export const ObjectUtil = {
  deepCopy: (obj: any = {}) => JSON.parse(JSON.stringify(obj)),
}
